<template>
    <el-card shadow="hover" :body-style="{ padding: '0' }" class="site-card">
        <div class="site-card-screenshot">
            <img :src="screenshot" :alt="name">
        </div>
        <div class="site-card-avatar">
            <img :src="avatar" :alt="name">
            <div class="site-card-info">
                <div class="site-card-name">{{ name }}</div>
                <div class="site-card-desc">{{ description }}</div>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: 'SiteCard',
    props: {
        screenshot: {
            type: String,
            required: true
        },
        avatar: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    }
}
</script>

<style scoped>
.site-card {
    width: 200px !important;
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
}

.site-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 12px -3px rgba(0, 122, 255, 0.2);
}

.site-card-screenshot {
    width: 100%;
    height: 120px;
    overflow: hidden;
    border-bottom: 1px solid rgba(0, 122, 255, 0.1);
    transition: height 0.3s ease;
}

.site-card:hover .site-card-screenshot {
    height: 80px;
}

.site-card-screenshot img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.3s ease;
}

.site-card-avatar {
    padding: 16px;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background: var(--adil-card-bg);
    transition: all 0.3s ease;
}

.site-card-avatar img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
}

.site-card-info {
    flex: 1;
    overflow: hidden;
}

.site-card-name {
    font-size: 14px;
    font-weight: bold;
    color: var(--adil-fontcolor);
    margin-bottom: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.site-card-desc {
    font-size: 12px;
    color: var(--adil-secondtext);
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.5;
    transition: all 0.3s ease;
    height: 36px;
}

.site-card:hover .site-card-desc {
    -webkit-line-clamp: unset;
    line-clamp: unset;
    height: 80px;
    overflow-y: auto;
}


.site-card-desc::-webkit-scrollbar-thumb {
    background: rgba(0, 122, 255, 0.2);
    border-radius: 2px;
}

.site-card-desc::-webkit-scrollbar-track {
    background: transparent;
}
</style> 